import { defineMessages } from 'react-intl';

export default defineMessages({
  surveyLimit: 'Active surveys/month',
  generalSurveyLimit: 'Active general surveys/month',
  feedbackLimit: 'Active feedbacks/month',
  targetedSurveyLimit: 'Active targeted surveys/month',
  cxSurveyLimit: 'Active CX surveys/year',
  customTheme: 'Custom survey theme',
  userSegmentLimit: 'Number of personal segments for each user',
  sharedSegmentLimit: 'Number of shared segments',
  matomoSegmentLimit: 'Number of segments synced to Matomo',
  matomoMonthlyVisitLimit: 'Number of monthly visits to Matomo',
  funnelLimit: 'Number of multi-dimensional funnels',
  tagComments: 'Categorize comments',
  aiSummaries: 'AI text summaries',
  userLimit: 'Number of users',
  advancedUserLimit: 'Number of advanced users',
  responseLimit: 'Responses/month',
  yearlyResponseLimit: 'Responses/year',
  accessibilityEnabled: 'Accessibility enabled',
  accessibilityPageLimit: 'Accessibility pages',
  generalSurveyTemplate: 'Template for general surveys',
  feedbackTemplate: 'Template for feedbacks',
  targetedSurveyTemplate: 'Template for targeted surveys',
  templateCustomerId: 'Customer ID for survey templates',
  globalBenchmarkCategoryId: 'Category ID for global benchmark',
  heatmapLimit: 'Number of heatmaps',
  heatmapSampleLimit: 'Number of heatmap samples',
  heatmapsDataRetentionDays: 'Heatmaps data retention in days',
  sessionRecordingLimit: 'Number of configured recordings',
  sessionRecordingSampleLimit: 'Number of recorded sessions',
  surveyVersionLimit: 'Number of versions',
  surveyLanguageLimit: 'Number of languages',
  customerOwnerRoleId: 'Customer owner role ID',
  customerAdvancedUserRoleId: 'Customer advanced user role ID',
  dataSourceOwnerRoleId: 'Data source owner role ID',
  dataSourceAdvancedUserRoleId: 'Data source advanced user role ID',
  dedicatedAnalyst: 'Dedicated analyst',
  unlimitedHeatmaps: 'Unlimited heatmaps and recordings',
  reportLimit: 'Number of reports',
  customCookiePrefix: 'Custom cookie prefix',
  disableCookies: 'Cookieless tracking',
  yearlyPrices: 'Yearly prices',
  monthlyPrices: 'Monthly prices',
  analytics: 'Analytics',
  monthlyPrice: 'Monthly price',
  monthlySinglePrice: 'Monthly single price',
  monthlyMultiplePrice: 'Monthly multiple price',
  prices: 'Prices',
  dataRetentionMonths: 'Data retention in months',
  dailyHeatmapSampleLimit: 'Heatmap samples/day',
  dailySessionRecordingLimit: 'Recorded sessions/day',
  actionLimit: 'Actions/month',
  visitLimit: 'Visits/month',
  pipedriveProductId: 'Pipedrive product ID',
  blockedDomains: 'Blocked domains',
  blockedEmailDomains: 'Blocked email domains',
  nextOrderNumber: 'Next order number',
  crashAnalytics: 'Crash analytics',
  formAnalytics: 'Form analytics',
  mediaAnalytics: 'Media analytics',
  eCommerceAnalytics: 'Ecommerce analytics',
  multiAttribution: 'Multi attribution',
  seoWebVitals: 'SEO web vitals',
  goalLimit: 'Number of goals',
  monthlyBrokenlinksCheckLimit: 'Broken links checks/month',
  brokenLinksWeeklyCheck: 'Check broken links weekly',
  brokenLinksMonthlyCheck: 'Check broken links monthly',
  advancedCampaignParameters: 'Advanced campaign parameters',
  expertCampaignParameters: 'Expert campaign parameters',
  emailTemplateUserInvitationEn: 'Email template: User invitation (EN)',
  emailTemplateReportEn: 'Email template: Report (EN)',
  emailTemplateReportSv: 'Email template: Report (SV)',
  emailTemplateReportNb: 'Email template: Report (NB)',
  emailTemplateContactQuestionEn: 'Email template: Contact question (EN)',
  emailTemplateClientPanelEn: 'Email template: Client panel (EN)',
  emailTemplateClientPanelSv: 'Email template: Client panel (SV)',
  emailTemplateClientPanelNb: 'Email template: Client panel (NB)',
  emailTemplateClientPanelDe: 'Email template: Client panel (DE)',
  emailTemplateClientPanelFi: 'Email template: Client panel (FI)',
  emailTemplateClientPanelDa: 'Email template: Client panel (DA)',
  emailTemplateClientPanelEs: 'Email template: Client panel (ES)',
  emailTemplateClientPanelIt: 'Email template: Client panel (IT)',
  emailTemplateClientPanelFr: 'Email template: Client panel (FR)',
  emailTemplatePasswordResetEn: 'Email template: Password reset (EN)',
  emailTemplateSignUpEn: 'Email template: Sign up (EN)',
  emailTemplateSignUpReminderEn: 'Email template: Sign up reminder (EN)',
  emailTemplateUserInvitationReminderEn: 'Email template: User invitation reminder (EN)',
  emailTemplateScriptInstallationReminderEn: 'Email template: Script installation reminder (EN)',
  emailTemplateScriptInstructionsEn: 'Email template: Script instructions (EN)',
  emailTemplateOrderConfirmationEn: 'Email template: Order confirmation (EN)',
  emailTemplateOrderRenewalEn: 'Email template: Order renewal (EN)',
  emailTemplateBrokenLinksReportEn: 'Email template: Broken links report (EN)',
  emailTemplateDemoSignupEn: 'Email template: Demo signup (EN)',
  emailTemplateSubprocessorSignupEn: 'Email template: Subprocessor signup (EN)',
  aiAutoTaggingSystemPrompt: 'AI tagging system prompt',
  aiSummarySystemPrompt: 'AI summary system prompt',
  aiCategorySystemPrompt: 'Category suggestion system prompt',
  aiDefaultModel: 'Default model',
  aiFallbackModels: 'Fallback models (CSV)',
  aiOpenaiApiKey: 'OpenAI API key',
  aiGoogleApiKey: 'Google AI Studio API key',
  aiAzureFoundryApiKey: 'Azure Foundry API key',
  aiAzureFoundryResourceName: 'Azure Foundry resource name',
  aiAzureFoundryApiVersion: 'Azure Foundry API version',
  incompleteSignupReminderDays: 'Reminder days: Incomplete signup',
  activeAccountInvitationReminderDays: 'Reminder days: Active account invitation',
  scriptInstallationReminderDays: 'Reminder days: Script installation',
});
